/* eslint-disable */
import React from 'react'
import Accordion from '../../components/accordion'
import Sidebar from './sidebar-payment'
import { Col } from 'react-flexbox-grid'
import styled from 'styled-components'
import Helmet from 'react-helmet'

import { useTranslation } from 'react-i18next'

const HelpPageStyle = styled.div`
  @media screen and (min-width: 300px) and (max-width: 700px) {
    .sidebar-help-custom-navigation {
      width: 100% !important;
      margin-bottom: 20px;
    }

    .sidebar-help-custom-content {
      width: 100% !important;
      padding-left: 0 !important;
    }
  }
`

const Payment = () => {
  const { t } = useTranslation()
  const data = [
    {
      title: t('pagePayment.part1'),
      number: 1,
      targetScroll: 'payment-1',
      child: {
        title: t('pagePayment.part2'),
        data: [
          {
            title: t('pagePayment.part3'),
            content: [
              {
                text: t('pagePayment.part4')
              }
            ]
          },
          {
            title: t('pagePayment.part5'),
            content: [
              {
                text: t('pagePayment.part6')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePayment.part7'),
      number: 2,
      targetScroll: 'payment-2',
      child: {
        title: t('pagePayment.part8'),
        data: [
          {
            title: t('pagePayment.part9'),
            content: [
              {
                text: t('pagePayment.part10')
              }
            ]
          },
          {
            title: t('pagePayment.part11'),
            content: [
              {
                text: t('pagePayment.part12')
              }
            ]
          },
          {
            title: t('pagePayment.part13'),
            content: [
              {
                text: t('pagePayment.part14')
              }
            ]
          },
          {
            title: t('pagePayment.part15'),
            content: [
              {
                text: t('pagePayment.part16')
              }
            ]
          },
          {
            title: t('pagePayment.part17'),
            content: [
              {
                text: t('pagePayment.part18')
              }
            ]
          },
          {
            title: t('pagePayment.part19'),
            content: [
              {
                text: t('pagePayment.part20')
              }
            ]
          },
          {
            title: t('pagePayment.part21'),
            content: [
              {
                text: t('pagePayment.part22')
              }
            ]
          },
          {
            title: t('pagePayment.part23'),
            content: [
              {
                text: t('pagePayment.part24')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePayment.part25'),
      number: 3,
      targetScroll: 'payment-3',
      child: {
        title: t('pagePayment.part26'),
        data: [
          {
            title: t('pagePayment.part27'),
            content: [
              {
                text: t('pagePayment.part28')
              },
              {
                text: t('pagePayment.part29')
              },
              {
                text: t('pagePayment.part30')
              },
              {
                text: t('pagePayment.part31')
              },
              {
                text: t('pagePayment.part32')
              },
              {
                text: t('pagePayment.part33')
              }
            ]
          },
          {
            title: t('pagePayment.part34'),
            content: [
              {
                text: t('pagePayment.part35')
              },
              {
                text: t('pagePayment.part36')
              },
              {
                text: t('pagePayment.part37')
              },
              {
                text: t('pagePayment.part38')
              },
              {
                text: t('pagePayment.part39')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePayment.part40'),
      number: 4,
      targetScroll: 'payment-4',
      child: {
        title: t('pagePayment.part41'),
        data: [
          {
            title: t('pagePayment.part42'),
            content: [
              {
                text: t('pagePayment.part43')
              },
              {
                text: t('pagePayment.part44')
              },
              {
                text: t('pagePayment.part45')
              },
              {
                text: t('pagePayment.part46')
              },
              {
                text: t('pagePayment.part47')
              },
              {
                text: t('pagePayment.part48')
              },
              {
                text: t('pagePayment.part49')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePayment.part50'),
      number: 5,
      targetScroll: 'payment-5',
      child: {
        title: t('pagePayment.part51'),
        data: [
          {
            title: t('pagePayment.part52'),
            content: [
              {
                text: t('pagePayment.part53')
              },
              {
                text: t('pagePayment.part54')
              },
              {
                text: t('pagePayment.part55')
              },
              {
                text: t('pagePayment.part56')
              },
              {
                text: t('pagePayment.part57')
              },
              {
                text: t('pagePayment.part58')
              },
              {
                text: t('pagePayment.part59')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePayment.part60'),
      number: 6,
      targetScroll: 'payment-6',
      child: {
        title: t('pagePayment.part61'),
        data: [
          {
            title: t('pagePayment.part62'),
            content: [
              {
                text: t('pagePayment.part63')
              },
              {
                text: t('pagePayment.part64')
              },
              {
                text: t('pagePayment.part65')
              },
              {
                text: t('pagePayment.part66')
              },
              {
                text: t('pagePayment.part67')
              },
              {
                text: t('pagePayment.part68')
              },
              {
                text: t('pagePayment.part69')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePayment.part70'),
      number: 7,
      targetScroll: 'payment-7',
      child: {
        title: t('pagePayment.part71'),
        data: [
          {
            title: t('pagePayment.part72'),
            content: [
              {
                text: t('pagePayment.part73')
              },
              {
                text: t('pagePayment.part74')
              },
              {
                text: t('pagePayment.part75')
              },
              {
                text: t('pagePayment.part76')
              },
              {
                text: t('pagePayment.part77')
              },
              {
                text: t('pagePayment.part78')
              },
              {
                text: t('pagePayment.part79')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePayment.part80'),
      number: 8,
      targetScroll: 'payment-8',
      child: {
        title: t('pagePayment.part81'),
        data: [
          {
            title: t('pagePayment.part82'),
            content: [
              {
                text: t('pagePayment.part83')
              },
              {
                text: t('pagePayment.part84')
              },
              {
                text: t('pagePayment.part85')
              },
              {
                text: t('pagePayment.part86')
              },
              {
                text: t('pagePayment.part87')
              },
              {
                text: t('pagePayment.part88')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePayment.part89'),
      number: 9,
      targetScroll: 'payment-9',
      child: {
        title: t('pagePayment.part90'),
        data: [
          {
            title: t('pagePayment.part91'),
            content: [
              {
                text: t('pagePayment.part92')
              },
              {
                text: t('pagePayment.part93')
              },
              {
                text: t('pagePayment.part94')
              },
              {
                text: t('pagePayment.part95')
              },
              {
                text: t('pagePayment.part96')
              },
              {
                text: t('pagePayment.part97')
              },
              {
                text: t('pagePayment.part98')
              }
            ]
          },
          {
            title: t('pagePayment.part99'),
            content: [
              {
                text: t('pagePayment.part100')
              },
              {
                text: t('pagePayment.part101')
              },
              {
                text: t('pagePayment.part102')
              },
              {
                text: t('pagePayment.part103')
              },
              {
                text: t('pagePayment.part104')
              },
              {
                text: t('pagePayment.part105')
              },
              {
                text: t('pagePayment.part106')
              },
              {
                text: t('pagePayment.part107')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePayment.part108'),
      number: 10,
      targetScroll: 'payment-10',
      child: {
        title: t('pagePayment.part109'),
        data: [
          {
            title: t('pagePayment.part110'),
            content: [
              {
                text: t('pagePayment.part111')
              },
              {
                text: t('pagePayment.part112')
              },
              {
                text: t('pagePayment.part113')
              },
              {
                text: t('pagePayment.part114')
              },
              {
                text: t('pagePayment.part115')
              }
            ]
          },
          {
            title: t('pagePayment.part116'),
            content: [
              {
                text: t('pagePayment.part117')
              },
              {
                text: t('pagePayment.part118')
              },
              {
                text: t('pagePayment.part119')
              },
              {
                text: t('pagePayment.part120')
              },
              {
                text: t('pagePayment.part121')
              },
              {
                text: t('pagePayment.part122')
              }
            ]
          },
          {
            title: t('pagePayment.part123'),
            content: [
              {
                text: t('pagePayment.part124')
              },
              {
                text: t('pagePayment.part125')
              },
              {
                text: t('pagePayment.part126')
              },
              {
                text: t('pagePayment.part127')
              },
              {
                text: t('pagePayment.part128')
              },
              {
                text: t('pagePayment.part129')
              },
              {
                text: t('pagePayment.part130')
              },
              {
                text: t('pagePayment.part131')
              }
            ]
          }
        ]
      }
    }
  ]

  return (
    <div style={{ width: '100%' }}>
      <HelpPageStyle>
        <Helmet>
          <title>Pembayaran | halojasa.com</title>
          <meta charSet="utf-8" />
          <meta name="description" content="Panduan Pembayaran Halo Jasa" />
          <meta property="og:title" content="Pembayaran | halojasa.com" />
          <meta property="og:site_name" content="Halo Jasa" />
          <meta
            property="og:description"
            content="Panduan Pembayaran Halo Jasa"
          />
          <meta
            property="og:url"
            content="https://halojasa.com/bantuan/cara-pembayaran/"
          />
          <meta
            property="og:image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta
            property="og:image:secure_url"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta
            property="og:image"
            itemProp="image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-sq.png"
          />
          <meta
            property="og:image:secure_url"
            itemProp="image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-sq.png"
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="300" />
          <meta property="og:image:height" content="300" />
          <meta property="og:type" content="website" />
          <meta property="fb:app_id" content="951866408583742" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@pthalojasa" />
          <meta name="twitter:title" content="Pembayaran | halojasa.com" />
          <meta
            name="twitter:description"
            content="Panduan Pembayaran Halo Jasa"
          />
          <meta
            name="twitter:image:src"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta name="keyword" content="pembayaran halo jasa" />
          <link
            rel="canonical"
            href="https://halojasa.com/bantuan/cara-pembayaran/"
          />
        </Helmet>
        <Col
          style={{
            width: '350px',
            display: 'inline-block',
            verticalAlign: 'top'
          }}
          className="sidebar-help-custom-navigation"
        >
          <Sidebar />
        </Col>

        <Col
          style={{
            width: 'calc(100% - 350px)',
            display: 'inline-block',
            verticalAlign: 'top',
            boxSizing: 'border-box',
            paddingLeft: '20px'
          }}
          className="sidebar-help-custom-content"
        >
          {data.map(item => {
            return (
              <Accordion key={item.number} {...item} withNumber></Accordion>
            )
          })}
        </Col>
      </HelpPageStyle>
    </div>
  )
}

export default Payment
